export default __webpack_public_path__ + "static/about-img-d36eb45e576e4da1c3f27ebde1e461c4.png";